export enum StatusBoleto {
  AEmitir = "AEmitir",
  EmAberto = "EmAberto",
  EmAtraso = "EmAtraso",
  Liquidado = "Liquidado",
  Cancelado = "Cancelado",
}

export const StatusBoletoLabel: Record<string, string> = {
  [StatusBoleto.AEmitir]: "A emitir",
  [StatusBoleto.EmAberto]: "Em aberto",
  [StatusBoleto.EmAtraso]: "Em atraso",
  [StatusBoleto.Liquidado]: "Liquidado",
  [StatusBoleto.Cancelado]: "Cancelado",
};

export const StatusBoletoCor: Record<string, string> = {
  [StatusBoleto.AEmitir]: "default",
  [StatusBoleto.EmAberto]: "blue",
  [StatusBoleto.EmAtraso]: "red",
  [StatusBoleto.Liquidado]: "green",
  [StatusBoleto.Cancelado]: "volcano",
};

export type BoletoType = {
  id: number;
  alunoId: number;
  matricula?: number;
  nomeAluno?: string;
  parcela?: number;
  valor?: number;
  dataVencimento?: string;
  dataEmissao?: string;
  dataLiquidacao?: string;
  status?: StatusBoleto;
  statusLabel?: string;
  motivoCancelamento?: string;
  unidadeId: number;
  unidadeNome?: string;
  trocaPagamentoNome?: string;
  trocaCv?: number;
  trocaDataTransacao?: string;
};
